<template>
  <div id="appSign">
    <com-loading></com-loading>
    <img src="./../assets/icon.png" alt="icon" />
    <div class="signInGroup" @click="handleGoogleSignIn">
      <span class="signInTitle">Google 登入/註冊</span>
    </div>
    <com-modal
      modalType="alert"
      alertType="fail"
      modalId="signAlertModal"
      :title="alertMsg"
    ></com-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import router from "@/router";
import { log } from "@/js/function";
export default {
  methods: {
    ...mapActions(["actionSignUp", "actionGoogleSignUp"]),
    ...mapMutations(["mutationLoading"]),
    handleFacebookSignIn() {
      ga("send", "event", "signInByFacebook", this.getUser.email);
      this.mutationLoading(true);
      this.actionSignUp()
        .then((result) => {
          this.mutationLoading(false);
          router.push({
            name: "list",
          });
        })
        .catch((err) => {
          this.mutationLoading(false);
          this.alertMsg = `登入失敗: ${err.message}`;
          this.$root.$emit("show::modal", "signAlertModal");
        });
    },
    handleGoogleSignIn() {
      ga("send", "event", "signInByGoogle", this.getUser.email);
      this.mutationLoading(true);
      this.actionGoogleSignUp()
        .then((result) => {
          this.mutationLoading(false);
          router.push({
            name: "list",
          });
        })
        .catch((err) => {
          this.mutationLoading(false);
          this.alertMsg = `登入失敗: ${err.message}`;
          this.$root.$emit("show::modal", "signAlertModal");
        });
    },
  },
  data: () => ({
    alertMsg: "",
  }),
  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  beforeCreate() {},
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        log("User is sign in");
        // router.push({ // auto sign in
        //     name: 'list',
        // });
      } else {
        log("User is not sign in");
      }
    });
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "../style/main.scss";
@import "../style/variable.scss";
#appSign {
  @include fullScreenCenter;
  background: $bodyBg;
  img {
    width: 200px;
    margin-left: -100px;
  }
  .signInGroup {
    cursor: pointer;
    width: 300px;
    margin-left: -50px;
    text-align: center;
    font-size: 2rem;
    font-weight: 800;
  }
}
</style>



// WEBPACK FOOTER //
// app-sign.vue?63307350